<script setup lang="ts">
import Logo from 'assets/images/svg/logo-en.svg';
import TgIcon from 'assets/images/svg/tg.svg';
import VkIcon from 'assets/images/svg/vk.svg';
import RutubeIcon from 'assets/images/svg/rutube.svg'
import MaxIcon from 'assets/images/svg/max.svg'
import PhoneIcon from 'assets/images/svg/phone.svg'

const footerText = await queryContent('/footer').findOne();
</script>

<template>
  <footer class="footer">
    <div class="container">
      <div class="footer__row">
        <div class="footer__left">
          <div class="footer__logo-wrapper">
            <Logo class="footer__logo" />
          </div>
        </div>
        <div class="footer__right">
          <div class="footer__contact">
            <a :href="`tel:${footerText.phone.replace(/\s+/g, '')}`" class="footer__phone" aria-label="Телефон">
              <div class="footer__phone-icon-wrapper">
                <PhoneIcon class="footer__phone-icon" />
              </div>
              <p class="footer__phone-number text-24">{{ footerText.phone }}</p>
            </a>
            <a :href="`mailto:${footerText.email}`" class="footer__email text-20">{{ footerText.email }}</a>
          </div>
          <div class="footer__socials">
            <a :href="`${footerText.telegram}`" class="footer__social footer__social--telegram" aria-label="Телеграм">
              <TgIcon />
            </a>
            <a :href="`${footerText.vk}`" class="footer__social footer__social--vk" aria-label="ВКонтакте">
              <VkIcon />
            </a>
            <a :href="`${footerText.rutube}`" class="footer__social footer__social--rutube" aria-label="Рутуб">
              <RutubeIcon class="footer__rutube-icon" />
            </a>
            <a :href="`${footerText.max}`" class="footer__social footer__social--max" aria-label="MAX">
              <MaxIcon />
            </a>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<style scoped lang="scss">
@use 'sass:color';

.footer {
  padding: 76px 0;

  @media (max-width: $medium) {
    padding: 40px 0;
  }

  @media (max-width: $mobile) {
    padding: 24px 0;
  }

  &__row {
    display: flex;
    justify-content: space-between;

    @media (max-width: $medium) {
      justify-content: center;
    }
  }

  &__phone-icon {
    fill: white;
  }

  &__logo-wrapper {
    @media (max-width: $medium) {
      display: none;
    }
  }

  &__logo {
    @media (max-width: $large) {
      max-width: 225px;
    }
  }

  &__phone-icon-wrapper {
    width: 40px;
    height: 40px;
    background-color: var(--primary-color);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    @include transition;

    @media (max-width: $medium) {
      display: none;
    }
  }

  &__left {
    display: flex;
    gap: 158px;

    @media (max-width: $large) {
      gap: 47px;
    }
  }

  &__menu-link {
    color: var(--dark-color);
    padding: 8px 16px;
    display: inline-block;

    @media (max-width: $large) {
      padding: 7px 16px;
    }
  }

  &__right {
    display: flex;
    gap: 110px;

    @media (max-width: $large) {
      gap: 47px;
    }

    @media (max-width: $medium) {
      gap: 36px;
      flex-direction: column;
    }

    @media (max-width: $mobile) {
      gap: 24px;
    }
  }

  &__contact {
    @media (max-width: $medium) {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 16px;
    }

    @media (max-width: $mobile) {
      gap: 10px;
    }
  }

  &__email {
    color: var(--dark-color);
    padding-left: 62px;
    @include transition;

    &:hover {
      color: color.adjust(#2c3136, $lightness: 30%)
    }

    @media (max-width: $medium) {
      padding-left: 0;
    }
  }

  &__rutube-icon {
    fill: white;
    width: 20px;
    height: 20px;
    position: relative;
    top: -2px;
    left: 2px;
  }

  &__phone {
    display: flex;
    gap: 20px;

    &:hover {
      .footer__phone-number {
        color: color.adjust(#2c3136, $lightness: 30%);
      }

      .footer__phone-icon-wrapper {
        background-color: color.adjust(#7f74ff, $lightness: 8%)
      }
    }
  }

  &__phone-number {
    color: var(--dark-color);
    letter-spacing: 1.2px;
    @include transition;

    &:hover {
      color: color.adjust(#2c3136, $lightness: 30%)
    }

    @media (max-width: $large) {
      font-size: 28px;
    }

    @media (max-width: $mobile) {
      font-size: 24px;
    }
  }

  &__socials {
    display: flex;
    gap: 15px;

    @media (max-width: $medium) {
      justify-content: center;
    }

    @media (max-width: $mobile) {
      gap: 13px;
    }
  }

  &__social {
    width: 48px;
    height: 48px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    @include transition;

    @media (max-width: $mobile) {
      width: 42px;
      height: 42px;
    }

    &--telegram {
      background: var(--primary-color);

      &:hover {
        background-color: color.adjust(#7F74FF, $lightness: 8%);
      }
    }

    &--vk {
      background: var(--info-color);

      &:hover {
        background-color: color.adjust(#749bff, $lightness: 8%);
      }
    }

    &--rutube {
      background: var(--success-color);

      &:hover {
        background-color: color.adjust(#75ccc2, $lightness: 8%);
      }
    }

    &--max {
      background: var(--primary-color);

      &:hover {
        background-color: color.adjust(#7F74FF, $lightness: 8%);
      }
    }
  }
}
</style>
